module.exports = __webpack_public_path__ + "img/5de881a.jpg";